export default {
    PREVIEW: 'Preview',
    LIVE: 'Live',
    FINAL: 'Final'
};
